import { render, staticRenderFns } from "./ArticuloList.vue?vue&type=template&id=629fa842&lang=pug&"
import script from "./ArticuloList.ts?vue&type=script&lang=ts&"
export * from "./ArticuloList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports